import type { CustomerOrderStatus } from '../customerOrdersApi'
import type { CustomerSupportRequestStatus } from '../customerSupportApi'

type Language = 'it' | 'en'

const orderStatusLabels: Record<Language, Record<CustomerOrderStatus, string>> = {
  it: {
    created: 'In lavorazione',
    paid: 'Pagato',
    shipped: 'Spedito',
    cancelled: 'Annullato',
  },
  en: {
    created: 'Processing',
    paid: 'Paid',
    shipped: 'Shipped',
    cancelled: 'Cancelled',
  },
}

const supportStatusLabels: Record<Language, Record<CustomerSupportRequestStatus, string>> = {
  it: {
    open: 'Aperto',
    in_progress: 'In lavorazione',
    resolved: 'Risolto',
    closed: 'Chiuso',
  },
  en: {
    open: 'Open',
    in_progress: 'In progress',
    resolved: 'Resolved',
    closed: 'Closed',
  },
}

export const toOrderStatusLabel = (status: CustomerOrderStatus, language: Language = 'it') =>
  orderStatusLabels[language][status]

export const toOrderStatusBadgeClasses = (status: CustomerOrderStatus) => {
  if (status === 'paid') {
    return 'ca-badge-success'
  }
  if (status === 'shipped') {
    return 'ca-badge-info'
  }
  if (status === 'cancelled') {
    return 'ca-badge-error'
  }
  return 'ca-badge-warning'
}

export const toSupportStatusLabel = (status: CustomerSupportRequestStatus, language: Language = 'it') =>
  supportStatusLabels[language][status]

export const toSupportStatusBadgeClasses = (status: CustomerSupportRequestStatus) => {
  if (status === 'in_progress') {
    return 'ca-badge-warning'
  }
  if (status === 'resolved') {
    return 'ca-badge-success'
  }
  if (status === 'closed') {
    return 'ca-badge-neutral'
  }
  return 'ca-badge-info'
}
